const regionNames = new Intl.DisplayNames(["en"], { type: "region" });

/** ISO-3166-1 alpha-2 Prüfung über die ICU-Daten von Node (keine eigene Liste zu pflegen). */
export function isValidCountryCode(code: string): boolean {
  if (!/^[A-Z]{2}$/.test(code)) return false;
  // Unbekannte Codes gibt ICU unverändert zurück; "EU"/"UN" sind keine Länder.
  if (code === "EU" || code === "UN" || code === "EZ") return false;
  return regionNames.of(code) !== code;
}

export const EU_COUNTRIES = new Set([
  "AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR", "GR", "HR", "HU",
  "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI", "SK",
]);

export const isEuCountry = (code: string) => EU_COUNTRIES.has(code);
